import { Controller } from "@hotwired/stimulus";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import "~/styles/my-photoswipe.scss";

export default class extends Controller {
  connect() {
    console.log('photoswipe.ts');
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.element as HTMLElement,
      children: 'a',                // all <a> tags inside the gallery
      pswpModule: () => import('photoswipe')
    });

    // Add Font Awesome button
    lightbox.on("uiRegister", () => {
      lightbox.pswp?.ui?.registerElement({
        name: "fullscreen-button",
        ariaLabel: "Toggle fullscreen",
        order: 9,
        isButton: true,
        html: '<i class="bi bi-fullscreen"></i>', // ✅ Use your FA icon here
        onClick: (event, el, pswp) => {
          toggleFullscreen(pswp.element!);
        }
      });
      lightbox.pswp?.ui?.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          lightbox.pswp?.on('change', () => {
            const currSlideElement = lightbox.pswp?.currSlide?.data.element;
            let captionHTML: string | null | undefined = '';
            if (currSlideElement) {
              captionHTML = currSlideElement.querySelector('img')?.getAttribute('alt');
            }
            if (captionHTML) {
              el.innerHTML = captionHTML;
              el.style.display = '';
            } else {
              el.style.display = 'none';
            }
          });
        }
      });
    });

    lightbox.init();
  }
}

// optional: use the browser Fullscreen API
function toggleFullscreen(el: HTMLElement) {
  if (!document.fullscreenElement) {
    el.requestFullscreen?.();
  } else {
    document.exitFullscreen?.();
  }
}